import { PKG_NAME } from './const';

export function capitalize(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
export function lowercase(str: string) {
  return str.charAt(0).toLowerCase() + str.slice(1);
}
export const getValue = (key: string) => {
  const value = localStorage.getItem(`${PKG_NAME}:${key}`);
  return value ? JSON.parse(atob(value)) : value;
}
export const removeValue = (key: string) => {
  return localStorage.removeItem(`${PKG_NAME}:${key}`);
}
export const setValue = (key: string, value: unknown) => {
  const val = btoa(JSON.stringify(value));
  localStorage.setItem(`${PKG_NAME}:${key}`, val);
}